import { connect, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Draggable } from "react-drag-reorder";
import {
  updateReportPriority,
  getReports,
} from "../../../../action/masters/reportActionCreator";
import {
  changePositionOnDrag,
  prioratiseItems,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep, baseURL } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import {
  IUpdateReportPriority,
  IReports,
} from "../../../../models/master/reports";
import { setReports } from "../../../../store/slices/master/reportSlice";
import LoaderSpinner from "../../../../common-components/loader";

const PriorityReports = (props: IUpdateReportPriority) => {
  const { updateReportPriority, getReports, reports, configUserRole } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const dispatch = useDispatch();
  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateReportPriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    /////method 1
    setLoader(true);
    
    let index = filteredItems.findIndex((x) => x.id == id);
    let _afterFilteration = [];
    let _filteredItems = [...filteredItems];
    let selectedItem = _filteredItems.splice(index, 1);
    selectedItem[0].displayOrNot = _displayOrNot;

    selectedItem[0].priority = null;
    _afterFilteration = [
      ...prioratiseItems(_filteredItems.filter((x) => x.displayOrNot == true)),
      ...selectedItem,
      ..._filteredItems.filter((x) => x.displayOrNot == false),
    ];
    let _items = prioratiseItems(_afterFilteration);
    
    setfilteredItems([..._items]);
    updateReportPriority(_items, setAlert);
    //let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
    // await setfilteredItems(_items);
    // //const itemsForSave = _items.slice(newPos);
    // updateAppPriority(_items, setAlert);

    /////method 2
    // let _filteredItems = [...filteredItems]
    // let item = _filteredItems[index];
    // item.displayOrNot = __displayOrNot;
    // _filteredItems[index] = item;
    // updateAppPriority(item, setAlert);
    // setFilteredItems(_filteredItems);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllReports = async (configUserRoleId: number) => {
    setLoader(true)
    try{
      await getReports(configUserRoleId);
    }
    finally{
      setLoader(false)
    }
  };

  useEffect(() => {
    getAllReports(configUserRole);
    return () => {
      dispatch(setReports([]));
    };
  }, [configUserRole]);

  useEffect(() => {
    reports && setfilteredItems(cloneDeep(reports));
  }, [reports]);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Reports</h2>
        </div>
  
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <LoaderSpinner/>
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: IReports) => item.displayOrNot)
                  .map((report: IReports, index: number) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">{report.priority}</span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={report.displayOrNot}
                            id={report.priority + "report"}
                            onChange={() => {
                              ChangeVisibleOrNot(
                                report.id ?? 0,
                                !report.displayOrNot
                              );
                            }}
                          />
                          <label htmlFor={report.priority + "report"}></label>
                        </div>
                      </div>
                      <div className="btm">
                        <div className="img">
                          <img
                            src={report.icon ? baseURL + report.icon : ""}
                            alt=""
                          />
                        </div>
                        <h2>{report.name}</h2>
                      </div>
                    </li>
                  ))}
              </Draggable>
              {filteredItems
                .filter((item: IReports) => !item.displayOrNot)
                .map((report: IReports, index: number) => (
                  <li className="admin-card">
                    <div className="top">
                      <span className="handle">
                        <img src="/assets/images/drag.svg" />
                      </span>
                      <span className="counter">{}</span>
                      <div className="form-checkbox">
                        <input
                          type="checkbox"
                          checked={report.displayOrNot}
                          id={report.priority + ""}
                          onChange={() => {
                            
                            ChangeVisibleOrNot(
                              report.id ?? 0,
                              !report.displayOrNot
                            );
                          }}
                        />
                        <label htmlFor={report.priority + ""}></label>
                      </div>
                    </div>
                    <div className="btm">
                      <div className="img">
                        <img
                          src={report.icon ? baseURL + report.icon : ""}
                          alt=""
                        />
                      </div>
                      <h2>{report.name}</h2>
                    </div>
                  </li>
                ))}
            </>
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  updateReportPriority: (data: any, callBack: Function) =>
    updateReportPriority(data, callBack),
  getReports: (configUserRole: number) => getReports(configUserRole),
};

function mapStateToProps(state: any) {
  return {
    reports: state.report.reports,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PriorityReports);
